exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-sources-empty[data-v-15be2ebf]{margin:0;color:var(--fts-settings-mute)}.fts-sources-scroll[data-v-15be2ebf]{overflow-x:auto}.fts-sources-scroll .fts-settings-table td strong[data-v-15be2ebf]{font-weight:600}.fts-sources-mono[data-v-15be2ebf]{font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace}.fts-sources-agent[data-v-15be2ebf]{flex-wrap:wrap}.fts-sources-agent-side[data-v-15be2ebf]{display:flex;flex-wrap:wrap;align-items:center;gap:12px}.fts-sources-approve-autocount[data-v-15be2ebf]{font-size:.8125rem}", ""]);

// exports
